const translations = {
  "payredirect.payment": "Debt payment",
  "payredirect.unoAcitve": "uno active",
  "payredirect.saerto": "saerto",
  "payredirect.pay": "pay",
};

export default translations;
